"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientErrorLevelEnum = exports.GroupEnum = exports.ActionEnum = exports.CallStateEnum = exports.GatewayNameEnum = exports.NotificationChannelEnum = exports.SoundEnum = exports.SmsPatternEnum = exports.IssuerTypeEnum = exports.DayOfWeek = exports.FileTypeEnum = exports.MongoQueryTypesEnum = exports.ChatTypeEnum = exports.EventTypeEnum = exports.IOStatusEnum = exports.ConferenceTypeEnum = exports.ConnectionQualityEnum = exports.VisitStatusEnum = exports.CallMetricsEventEnum = exports.DebugType = exports.TransactionTypeEnum = exports.SendStatusEnum = exports.ActivityStatusEnum = exports.GenderEnum = exports.ParticipantStateEnum = exports.OfficeTypeEnum = exports.UserTypeEnum = void 0;
var UserTypeEnum;
(function (UserTypeEnum) {
    UserTypeEnum["PATIENT"] = "PATIENT";
    UserTypeEnum["DOCTOR"] = "DOCTOR";
})(UserTypeEnum || (exports.UserTypeEnum = UserTypeEnum = {}));
var OfficeTypeEnum;
(function (OfficeTypeEnum) {
    OfficeTypeEnum["HOSPITAL"] = "HOSPITAL";
    OfficeTypeEnum["CLINIC"] = "CLINIC";
})(OfficeTypeEnum || (exports.OfficeTypeEnum = OfficeTypeEnum = {}));
var ParticipantStateEnum;
(function (ParticipantStateEnum) {
    ParticipantStateEnum["connecting"] = "connecting";
    ParticipantStateEnum["reconnecting"] = "reconnecting";
    ParticipantStateEnum["connected"] = "connected";
})(ParticipantStateEnum || (exports.ParticipantStateEnum = ParticipantStateEnum = {}));
var GenderEnum;
(function (GenderEnum) {
    GenderEnum["MALE"] = "male";
    GenderEnum["FEMALE"] = "female";
    GenderEnum["UNKNOWN"] = "unknown";
})(GenderEnum || (exports.GenderEnum = GenderEnum = {}));
var ActivityStatusEnum;
(function (ActivityStatusEnum) {
    ActivityStatusEnum["TYPING"] = "TYPING";
    ActivityStatusEnum["IDLE"] = "IDLE";
    ActivityStatusEnum["SENDING_MEDIA"] = "SENDING_MEDIA";
    ActivityStatusEnum["RECORDING_VOICE"] = "RECORDING_VOICE";
})(ActivityStatusEnum || (exports.ActivityStatusEnum = ActivityStatusEnum = {}));
var SendStatusEnum;
(function (SendStatusEnum) {
    SendStatusEnum["FAILED"] = "FAILED";
    SendStatusEnum["SENDING"] = "SENDING";
    SendStatusEnum["SENT"] = "SENT";
    SendStatusEnum["DELIVERED"] = "DELIVERED";
})(SendStatusEnum || (exports.SendStatusEnum = SendStatusEnum = {}));
var TransactionTypeEnum;
(function (TransactionTypeEnum) {
    TransactionTypeEnum["GATEWAY"] = "GATEWAY";
    TransactionTypeEnum["MISCELLANEOUS"] = "MISCELLANEOUS";
    TransactionTypeEnum["STARTER_CHARGE"] = "STARTER_CHARGE";
    TransactionTypeEnum["VISIT_PAYMENT"] = "VISIT_PAYMENT";
    TransactionTypeEnum["SETTLEMENT"] = "SETTLEMENT";
    TransactionTypeEnum["REFUND_VISIT_PAYMENT"] = "REFUND_VISIT_PAYMENT";
})(TransactionTypeEnum || (exports.TransactionTypeEnum = TransactionTypeEnum = {}));
var DebugType;
(function (DebugType) {
    DebugType["outgoing"] = "outgoing";
    DebugType["incoming"] = "incoming";
    DebugType["presence"] = "presence";
    DebugType["remote_logs"] = "remote_logs";
})(DebugType || (exports.DebugType = DebugType = {}));
var CallMetricsEventEnum;
(function (CallMetricsEventEnum) {
    CallMetricsEventEnum["REQUEST_RECEIVED"] = "REQUEST_RECEIVED";
    CallMetricsEventEnum["REQUEST_CANCELLED_BY_OTHER"] = "REQUEST_CANCELLED_BY_OTHER";
    CallMetricsEventEnum["REJECT_CLICKED"] = "REJECT_CLICKED";
    CallMetricsEventEnum["ACCEPT_CLICKED"] = "ACCEPT_CLICKED";
    CallMetricsEventEnum["RING_STATE_CHANGED"] = "RING_STATE_CHANGED";
    CallMetricsEventEnum["END_CALL_CLICKED"] = "END_CALL_CLICKED";
    CallMetricsEventEnum["OTHER_SIDE_BUSY"] = "OTHER_SIDE_BUSY";
    CallMetricsEventEnum["PIP_CLICKED"] = "PIP_CLICKED";
    CallMetricsEventEnum["FULLSCREEN_CLICKED"] = "FULLSCREEN_CLICKED";
    CallMetricsEventEnum["SOCKET_STATE_CHANGED"] = "SOCKET_STATE_CHANGED";
    CallMetricsEventEnum["CALL_CLOSED"] = "CALL_CLOSED";
    CallMetricsEventEnum["CAMERA_SWITCH_CLICKED"] = "CAMERA_SWITCH_CLICKED";
    CallMetricsEventEnum["MUTE_CLICKED"] = "MUTE_CLICKED";
    CallMetricsEventEnum["SPEAKER_CLICKED"] = "SPEAKER_CLICKED";
    CallMetricsEventEnum["AUDIO_ROUTE_CHANGED"] = "AUDIO_ROUTE_CHANGED";
    CallMetricsEventEnum["TRACK_STATE_CHANGED"] = "TRACK_STATE_CHANGED";
    CallMetricsEventEnum["TRACK_CREATED"] = "TRACK_CREATED";
    CallMetricsEventEnum["TRACK_STOPPED"] = "TRACK_STOPPED";
    CallMetricsEventEnum["CALL_STATE_CHANGED"] = "CALL_STATE_CHANGED";
    CallMetricsEventEnum["RTC_CONNECTION_STATE_CHANGED"] = "RTC_CONNECTION_STATE_CHANGED";
    CallMetricsEventEnum["RTC_ICE_CANDIDATE"] = "RTC_ICE_CANDIDATE";
    CallMetricsEventEnum["RTC_ICE_CANDIDATE_ERROR"] = "RTC_ICE_CANDIDATE_ERROR";
    CallMetricsEventEnum["RTC_ICE_CONNECTION_STATE_CHANGED"] = "RTC_ICE_CONNECTION_STATE_CHANGED";
    CallMetricsEventEnum["RTC_ICE_GATHERING_STATE_CHANGED"] = "RTC_ICE_GATHERING_STATE_CHANGED";
    CallMetricsEventEnum["RTC_NEGOTIATION_NEEDED"] = "RTC_NEGOTIATION_NEEDED";
    CallMetricsEventEnum["RTC_SIGNALING_STATE_CHANGED"] = "RTC_SIGNALING_STATE_CHANGED";
    CallMetricsEventEnum["STREAM_INJECTED_TO_ELEMENT"] = "STREAM_INJECTED_TO_ELEMENT";
    CallMetricsEventEnum["STREAM_REMOVED_FROM_ELEMENT"] = "STREAM_REMOVED_FROM_ELEMENT";
    CallMetricsEventEnum["STATS"] = "STATS";
    CallMetricsEventEnum["QUALITY_CHANGE"] = "QUALITY_CHANGE";
    CallMetricsEventEnum["OTHER_SIDE_READY"] = "OTHER_SIDE_READY";
    CallMetricsEventEnum["READY_ACKNOWLEDGED"] = "READY_ACKNOWLEDGED";
    CallMetricsEventEnum["ERROR"] = "ERROR";
    CallMetricsEventEnum["LOG"] = "LOG";
    CallMetricsEventEnum["NETWORK_STATE_CHANGED"] = "NETWORK_STATE_CHANGED";
    CallMetricsEventEnum["PING"] = "PING";
    CallMetricsEventEnum["BATTERY_STATE"] = "BATTERY_STATE";
})(CallMetricsEventEnum || (exports.CallMetricsEventEnum = CallMetricsEventEnum = {}));
var VisitStatusEnum;
(function (VisitStatusEnum) {
    VisitStatusEnum["IN_QUEUE"] = "IN_QUEUE";
    VisitStatusEnum["STARTED"] = "STARTED";
    VisitStatusEnum["ENDED"] = "ENDED";
    VisitStatusEnum["CANCELLED"] = "CANCELLED";
})(VisitStatusEnum || (exports.VisitStatusEnum = VisitStatusEnum = {}));
var ConnectionQualityEnum;
(function (ConnectionQualityEnum) {
    ConnectionQualityEnum["excellent"] = "excellent";
    ConnectionQualityEnum["fair"] = "fair";
    ConnectionQualityEnum["poor"] = "poor";
    ConnectionQualityEnum["bad"] = "bad";
})(ConnectionQualityEnum || (exports.ConnectionQualityEnum = ConnectionQualityEnum = {}));
var ConferenceTypeEnum;
(function (ConferenceTypeEnum) {
    ConferenceTypeEnum["audio"] = "audio";
    ConferenceTypeEnum["video"] = "video";
})(ConferenceTypeEnum || (exports.ConferenceTypeEnum = ConferenceTypeEnum = {}));
var IOStatusEnum;
(function (IOStatusEnum) {
    IOStatusEnum["READY"] = "READY";
    IOStatusEnum["DOWNLOADING"] = "DOWNLOADING";
    IOStatusEnum["UPLOADING"] = "UPLOADING";
    IOStatusEnum["WAITING_FOR_UPLOAD"] = "WAITING_FOR_UPLOAD";
    IOStatusEnum["WAITING_FOR_DOWNLOAD"] = "WAITING_FOR_DOWNLOAD";
    IOStatusEnum["UNKNOWN"] = "UNKNOWN";
})(IOStatusEnum || (exports.IOStatusEnum = IOStatusEnum = {}));
var EventTypeEnum;
(function (EventTypeEnum) {
    EventTypeEnum["DISPLAY_MESSAGE"] = "display-message";
    EventTypeEnum["STATE_UPDATE"] = "state-update";
    EventTypeEnum["CALL_REQUEST"] = "call-request";
    EventTypeEnum["CALL_ACCEPTED"] = "call-accepted";
    EventTypeEnum["CALL_ENDED"] = "call-ended";
    EventTypeEnum["ACTIVITY_STATUS"] = "activity-status";
    EventTypeEnum["EXCHANGE_SDP"] = "exchange-sdp";
    EventTypeEnum["MESSAGE_ACK"] = "message-ack";
    EventTypeEnum["CONVERSATIONS"] = "conversations";
    EventTypeEnum["MEDIA_CONFIGS"] = "media-configs";
    EventTypeEnum["AUTHENTICATED"] = "authenticated";
    EventTypeEnum["MESSAGE"] = "message";
    EventTypeEnum["CALL_ANALYTICS"] = "call-analytics";
    EventTypeEnum["VISIT_INITIATED"] = "visit-initiated";
    EventTypeEnum["VISIT_ACCEPTED"] = "visit-accepted";
    EventTypeEnum["VISIT_ENDED"] = "visit-ended";
    EventTypeEnum["CLIENT_ERROR"] = "client-error";
    EventTypeEnum["UPDATE_CHAT"] = "update-chat";
    EventTypeEnum["DELETE_CHAT"] = "delete-chat";
    EventTypeEnum["PLAY_SOUND"] = "play-sound";
    EventTypeEnum["SERVER_TIME"] = "server-time";
    EventTypeEnum["LOCAL_NOTIFICATION"] = "local-notification";
})(EventTypeEnum || (exports.EventTypeEnum = EventTypeEnum = {}));
var ChatTypeEnum;
(function (ChatTypeEnum) {
    ChatTypeEnum["TEXT"] = "TEXT";
    ChatTypeEnum["FILE"] = "FILE";
})(ChatTypeEnum || (exports.ChatTypeEnum = ChatTypeEnum = {}));
var MongoQueryTypesEnum;
(function (MongoQueryTypesEnum) {
    MongoQueryTypesEnum["FIND_ONE"] = "findOne";
    MongoQueryTypesEnum["FIND_MANY"] = "findMany";
    MongoQueryTypesEnum["PAGINATE"] = "paginate";
})(MongoQueryTypesEnum || (exports.MongoQueryTypesEnum = MongoQueryTypesEnum = {}));
var FileTypeEnum;
(function (FileTypeEnum) {
    FileTypeEnum["IMAGE"] = "IMAGE";
    FileTypeEnum["PDF"] = "PDF";
    FileTypeEnum["VIDEO"] = "VIDEO";
    FileTypeEnum["GIF"] = "GIF";
    FileTypeEnum["AUDIO"] = "AUDIO";
    FileTypeEnum["UNKNOWN"] = "UNKNOWN";
})(FileTypeEnum || (exports.FileTypeEnum = FileTypeEnum = {}));
var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek[DayOfWeek["SUNDAY"] = 0] = "SUNDAY";
    DayOfWeek[DayOfWeek["MONDAY"] = 1] = "MONDAY";
    DayOfWeek[DayOfWeek["TUESDAY"] = 2] = "TUESDAY";
    DayOfWeek[DayOfWeek["WEDNESDAY"] = 3] = "WEDNESDAY";
    DayOfWeek[DayOfWeek["THURSDAY"] = 4] = "THURSDAY";
    DayOfWeek[DayOfWeek["FRIDAY"] = 5] = "FRIDAY";
    DayOfWeek[DayOfWeek["SATURDAY"] = 6] = "SATURDAY";
})(DayOfWeek || (exports.DayOfWeek = DayOfWeek = {}));
var IssuerTypeEnum;
(function (IssuerTypeEnum) {
    IssuerTypeEnum["USER"] = "user";
    IssuerTypeEnum["ADMIN"] = "admin";
    IssuerTypeEnum["CREDIT_CARD"] = "credit-card";
})(IssuerTypeEnum || (exports.IssuerTypeEnum = IssuerTypeEnum = {}));
var SmsPatternEnum;
(function (SmsPatternEnum) {
    SmsPatternEnum["NEW_PATIENT"] = "new-patient";
    SmsPatternEnum["WORK_TIME_NEAR"] = "work-time-near";
    SmsPatternEnum["WORK_TIME_STARTED"] = "work-time-started";
    SmsPatternEnum["WORK_TIME_ENDED"] = "work-time-ended";
    SmsPatternEnum["OTP"] = "otp";
    SmsPatternEnum["NOTIFY_ADMIN"] = "notify-admin";
})(SmsPatternEnum || (exports.SmsPatternEnum = SmsPatternEnum = {}));
var SoundEnum;
(function (SoundEnum) {
    SoundEnum["NEW_PATIENT"] = "new_patient";
    SoundEnum["VISIT_STARTED"] = "visit_started";
    SoundEnum["VISIT_TIME_ENDED"] = "visit_time_ended";
    SoundEnum["QUEUE_TONE"] = "queue_tone";
    SoundEnum["DIAL_TONE"] = "dial_tone";
    SoundEnum["RINGING"] = "ringing";
    SoundEnum["DEFAULT_NOTIFICATION"] = "default_notification";
})(SoundEnum || (exports.SoundEnum = SoundEnum = {}));
var NotificationChannelEnum;
(function (NotificationChannelEnum) {
    NotificationChannelEnum["DEFAULT"] = "default";
    NotificationChannelEnum["NEW_PATIENT"] = "new_patient";
    NotificationChannelEnum["VISIT_STARTED"] = "visit_started";
})(NotificationChannelEnum || (exports.NotificationChannelEnum = NotificationChannelEnum = {}));
var GatewayNameEnum;
(function (GatewayNameEnum) {
    GatewayNameEnum["SEP"] = "sep";
    GatewayNameEnum["ZARINPAL"] = "zarinpal";
    GatewayNameEnum["SAMAN"] = "saman";
})(GatewayNameEnum || (exports.GatewayNameEnum = GatewayNameEnum = {}));
var CallStateEnum;
(function (CallStateEnum) {
    CallStateEnum["initiating"] = "initiating";
    CallStateEnum["transmitting"] = "transmitting";
    CallStateEnum["ended"] = "ended";
})(CallStateEnum || (exports.CallStateEnum = CallStateEnum = {}));
var ActionEnum;
(function (ActionEnum) {
    ActionEnum["CREATE"] = "create";
    ActionEnum["UPDATE"] = "update";
    ActionEnum["DELETE"] = "delete";
    ActionEnum["READ"] = "read";
})(ActionEnum || (exports.ActionEnum = ActionEnum = {}));
var GroupEnum;
(function (GroupEnum) {
    GroupEnum["ADMINS"] = "admins";
    GroupEnum["USERS"] = "users";
    GroupEnum["SELF"] = "self";
})(GroupEnum || (exports.GroupEnum = GroupEnum = {}));
var ClientErrorLevelEnum;
(function (ClientErrorLevelEnum) {
    ClientErrorLevelEnum["ERROR"] = "error";
    ClientErrorLevelEnum["WARNING"] = "warning";
    ClientErrorLevelEnum["CRITICAL"] = "critical";
})(ClientErrorLevelEnum || (exports.ClientErrorLevelEnum = ClientErrorLevelEnum = {}));
